package diana.soleil.design.iraniancanadienbazzar.core.data

import diana.soleil.design.iraniancanadienbazzar.core.common.AppPreferences
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

/**
 * Holds the user's interest category ids as observable state, **persisted** via [AppPreferences] so
 * they survive restarts. Picked during onboarding (skippable); Home uses them to bias category and
 * "popular" ordering. Signed-in accounts mirror the set to `users/{uid}.interests` via
 * `UserPreferencesSync` (adopt-down union on sign-in, push-up on change — same contract as favorites).
 */
class InterestsController(private val preferences: AppPreferences) {
    private val _interests = MutableStateFlow(preferences.interestCategoryIds)
    val interests: StateFlow<Set<String>> = _interests.asStateFlow()

    fun setInterests(categoryIds: Set<String>) {
        preferences.interestCategoryIds = categoryIds
        _interests.value = categoryIds
    }

    fun toggle(categoryId: String) {
        val current = _interests.value
        setInterests(if (categoryId in current) current - categoryId else current + categoryId)
    }

    /** Union-merge (used by sign-in adoption so device picks are never lost). */
    fun addAll(categoryIds: Collection<String>) {
        if (categoryIds.isEmpty()) return
        setInterests(_interests.value + categoryIds)
    }
}
